import moment from 'moment'
import React,{useState,useEffect,useRef,useCallback} from 'react'
import { Vehicle,graphData} from '../../sdk'
import { Loader } from '../Default'
import { DataTable } from '../Default/DataTables/DataTable'
import { toasterFunction } from '../Default/ToasterComponent'
export const MainContent=()=> {
  const [state,setState]=useState({loader:true,date:moment().format("yyyy-MM-DD"),actualData:[],data:[],
  tbHeader:[{title:"#",name:"count"},{title:"NumberPlate",name:"name"},{title:"Operations",name:"operations"}],
  updated:false,tableLoader:false,
  buttonLoader:false,
  buttonDisabled:false,
  roles:[],
  count:1,
  imgPreview:"",
  formAttr:{
    numberPlate:"",
    
  },
  updateFormAttr:{
    numberPlate:"",
    id:0,
    index:0,
    
    
  }
  });
  const ref=useRef();
  const ref2=useRef();
  const onHandler=(event)=>{
    let key=event.target.name;
    let value=event.target.value;
    let oldState={...state}
    if(key==="img"){
      oldState.imgPreview=URL.createObjectURL(event.target.files[0]);
      oldState.formAttr[key]=event.target.files[0];
    }
    else{
      oldState.formAttr[key]=value;
    }
     
    setState((pre)=>{
      return {...pre,...oldState}
    })
    
  }
  const onUpdateHandler=(event)=>{
    let key=event.target.name;
    let value=event.target.value;
    let oldState={...state}
    oldState.updateFormAttr[key]=value 
    setState((pre)=>{
      return {...pre,...oldState}
    })
    
  }
  const apiData=async()=>{
    try{
    let users=await new Vehicle().getAllData();
    let arr=[];
    let count=1;
     if(users.length){
     for(let val of users){
       arr.push([count,val.numberPlate,`<button type="button" class="btn btn-danger delete" data-index=${count} data-id=${val._id}><i class="fa fa-trash" aria-hidden="true"></i></button>`])
       count++;
      }
    }
    setState((pre)=>{
      return {...pre,data:arr,loader:false,tableLoader:false,actualData:users,roles:[],count}
   })
   }catch(e){
    console.log(e)
    alert("error occur")
    }

}
const onDelete=async (id,index)=>{
 try{
 
      if(window.confirm("are you want to delete this")){
        await new Vehicle().delete({id});
        let oldState={...state};
        toasterFunction.success("Vehicle has been deleted")
        oldState.data=oldState.data.filter(val=>Number(val[0]) !==Number(index));
        oldState.actualData=oldState.actualData.filter(val=>Number(val.id) !==Number(id));
        setState((pre)=>{
          return {...pre,...oldState,}
        })
      }
     
    }catch(e){
    console.log(e)
    }
    
}

const onUpdate=(id,index)=>{
let data=state.actualData.find(val=> Number(val.id)===Number(id));
 if(data){
  let oldState={...state};
  oldState.updateFormAttr={...oldState.updateFormAttr,email:data.user_email,name:data.name,password:data.user_password,role:data.role_id,id,index};
  window.$("#showEditForm").modal("show")
  setState((pre)=>{
    return {...pre,...oldState}
  })
 }
 else{
  alert("data not found")
 }
  
}
const modalHandler=(id=false)=>{
window.$("#showForm").modal("show")
}
const onSubmitAdd=async (event)=>{
  event.preventDefault();
  ref.current.disabled=true;
  ref.current.firstElementChild.style.display="inline-block"
 try{
 let result=await new Vehicle().Add(state.formAttr);
let oldState={...state};
toasterFunction.success("Vehicle has been added");
let newArr=[oldState.count,result.numberPlate,`<button type="button" class="btn btn-danger delete" data-index=${oldState.count}  data-id=${result.id}><i class="fa fa-trash" aria-hidden="true"></i></button>`]
// oldState.data=[newArr,...oldState.data];
oldState.actualData.push(result);
oldState.data.push(newArr);
oldState.count=oldState.count +1;
ref.current.disabled=false;
ref.current.firstElementChild.style.display="none"
window.$(".modal").modal("hide");
setState((pre)=>{
  return {...pre,...oldState}
})

}catch(e){
  toasterFunction.error("vehicle already added")
//  if(e.response.status===300){
//   toasterFunction.error("email already taken")
// }
// else{
//   toasterFunction.error(e.response.data.message)
// }
ref.current.disabled=false;
ref.current.firstElementChild.style.display="none"
}
}
const onSubmitUpdate=async (event)=>{
  event.preventDefault();
  ref2.current.disabled=true;
  ref2.current.firstElementChild.style.display="inline-block"
 
try{
let result=await new graphData().updateUser({...state.updateFormAttr,permissions:JSON.stringify(state.updateFormAttr.permissions)});
let oldState={...state};
toasterFunction.success("role has been updated");
ref2.current.disabled=false;
ref2.current.firstElementChild.style.display="none"
oldState.data=oldState.data.map(val=>{
if(Number(state.updateFormAttr.index)===Number(val[0])){
  return [val[0],result.name,result.user_email,result.user_password,result.roleName,`<button type="button" class="btn btn-danger delete" data-index=${val[0]} data-id=${result.id}><i class="fa fa-trash" aria-hidden="true"></i></button> <button type="button" class="btn btn-default update" data-index=${val[0]} data-id=${result.id}><i class="fa fa-pencil" aria-hidden="true"></i></button>`]
}
else{
  return val
}
});
oldState.actualData=oldState.actualData.map(val=>{
if(Number(state.updateFormAttr.id) !== Number(val.id)){
  return val;
}
else{
  return result;
}
});
window.$(".modal").modal("hide");
setState((pre)=>{
  return {...pre,...oldState}
})

}catch(e){
  console.log(e);
  if(e.response.status===300){
  toasterFunction.error("name already taken")
}
else{
  toasterFunction.error(e.response.data.message)
}
ref2.current.disabled=false;
ref2.current.firstElementChild.style.display="none"
}
}

useEffect(()=>{
apiData();
},[])
if(!state.loader){
  return (
    <>
      <div className="card mb-3">
       {/* BEGIN card-body */}
       <div className="card-body">
   <div className="col-12 mb-4">
     <div className="row">
       <div className="col-10">
       <div className="fw-bold mb-3">
   <span className="flex-grow-1 text-white">Vehicles</span>
   </div> 
       </div>
       <div className="col-2" style={{textAlign:"end"}}>
       <button type="button" class="btn btn-theme" onClick={modalHandler}>Add new Vehicle</button>
       </div>
      
     </div>
  
   </div>
   {state.tableLoader && <><Loader/></>}
   
   <div className="col-12">
  <DataTable headers={state.tbHeader} data={state.data} image={true} updated={state.updated} parentFun={{onDelete}}/>
  
   </div>
   </div>
   <div className="card-arrow">
         <div className="card-arrow-top-left" />
         <div className="card-arrow-top-right" />
         <div className="card-arrow-bottom-left" />
         <div className="card-arrow-bottom-right" />
       </div>
   </div>
   
   <div class="modal" id="showForm">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Add New Vehicle</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
      </div>
      <div class="modal-body">
        <div className="row">
          <div className="col-12">
           <form onSubmit={onSubmitAdd}>
          <div className="row">
          <div className="col-xl-6" >
          <div className="form-group mb-3">
          <label className="form-label text-white" >
              Number Plate
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Number Plate"
              name='numberPlate'
              value={state.formAttr.numberPlate}
              onChange={onHandler}
              required
            />
          </div>
        </div>
     
     
      
          <div className="col-xl-12"style={{textAlign:"center"}}>
          <button type="submit" class="btn btn-outline-theme w-25" ref={ref} disabled={false}>Add <div className="spinner-border" role="status" style={{height:"15px",width: "1rem" ,display:"none"}}></div></button>
          </div>
     
      </div>
    </form>
  </div>

        </div>
       </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-default " data-bs-dismiss="modal">Close</button>
        
      </div>
    </div>
     
     
    </div>
  </div>
</div>
<div class="modal" id="showEditForm">
<div class="modal-dialog modal-xl">
    <div class="modal-content">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Edit User</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
      </div>
      <div class="modal-body">
        <div className="row">
          <div className="col-12">
           <form onSubmit={onSubmitUpdate}>
          <div className="row">
          <div className="col-xl-6" >
          <div className="form-group mb-3">
          <label className="form-label text-white" >
              Name
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Name"
              name='name'
              value={state.updateFormAttr.name}
              onChange={onUpdateHandler}
              required
            />
          </div>
        </div>
        <div className="col-xl-6" >
          <div className="form-group mb-3">
          <label className="form-label text-white" >
              Email
            </label>
            <input
              type="email"
              className="form-control"
              placeholder="Enter Email"
              name='email'
              value={state.updateFormAttr.email}
              onChange={onUpdateHandler}
              required
            />
          </div>
        </div>
        <div className="col-xl-6" >
          <div className="form-group mb-3">
          <label className="form-label text-white" >
              Password
            </label>
            <input
              type="password"
              className="form-control"
              placeholder="Enter Password"
              name='password'
              value={state.updateFormAttr.password}
              onChange={onUpdateHandler}
              minLength={4}
              required
            />
          </div>
        </div>
     
     
        <div className="col-xl-6">
                                  <div class="form-group mb-3">
                                    <label class="form-label" for="exampleFormControlSelect1">Select Role</label>
                                    <select class="form-select" id="exampleFormControlSelect1" onChange={onUpdateHandler} name="role" required>
                                      <option value="">Select Role</option>
                                     {state.roles.map((v,index)=>{
                                          return (<>
                                          <option key={index} value={v.id} selected={Number(v.id) ===Number(state.updateFormAttr.role)}>{v.name}</option>
                                          
                                          </>)
                                     })}
                                    </select>
                                  </div>
                                
                </div>
                <div className="col-xl-6" >
          <div className="form-group mb-3">
          <label className="form-label text-white" >
          Designation
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Designation"
              name='designation'
              value={state.updateFormAttr.designation}
              onChange={onUpdateHandler}
              minLength={2}
              required
            />
          </div>
        </div>
                <div className="col-xl 6">
        <div class="mb-3">
														<label class="form-label" for="lgFile">Large file input example</label>
														<input type="file" class="form-control form-control-lg" id="lgFile" />
													</div>
        </div>
          <div className="col-xl-12"style={{textAlign:"center"}}>
          <button type="submit" class="btn btn-outline-theme w-25" ref={ref2} disabled={false}>Edit <div className="spinner-border" role="status" style={{height:"15px",width: "1rem" ,display:"none"}}></div></button>
          </div>
     
      </div>
    </form>
  </div>

        </div>
       </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-default " data-bs-dismiss="modal">Close</button>
        
      </div>
    </div>
     
     
    </div>
  </div>
</div>


 </>
 
    
   )
}
else{
  return (<>
  <Loader/>
  </>)
}
  
}
